import React from 'react';
import { isGifDeviation, isVideoDeviation } from '../../../../../_helpers';
import DeviationTypeFilm from '@wix/da-ds/pkg/Icons/DeviationType/Film';
import DeviationTypeGif from '@wix/da-ds/pkg/Icons/DeviationType/Gif';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
var MediaIcon = function (_a) {
    var deviation = _a.deviation;
    if (isVideoDeviation(deviation)) {
        return React.createElement(DeviationTypeFilm, { size: IconSize.MEDIUM });
    }
    if (isGifDeviation(deviation)) {
        return React.createElement(DeviationTypeGif, { size: IconSize.MEDIUM });
    }
    return null;
};
MediaIcon.displayName = 'MediaIcon';
export default MediaIcon;
//# sourceMappingURL=MediaIcon.js.map